<template>
    <!-- <AdminLayout> -->
      <section class="flex items-start">
          <div class="w-full">
              <div class="mt-12">
                  <div class="border rounded-lg py-4 px-5">
                    <div class="flex justify-between mb-8">
                        <p class="font-semibold text-xl text-neutral-800">Leave Carry Forward & Payouts </p>
                        <div class="ml-auto" v-if="userType === 'admin'">
                          <label class="text-sm leading-none font-normal text-black mr-2">Filter:</label>
                          <select class="border rounded-lg px-2 py-2 text-sm" v-model="slectedLocation" @change="fetchLeaveRecords">
                            <option value="">Location</option>
                            <option v-for="branch in branchList" :key="branch.id" :value="branch.id">{{ branch.name }}</option>
                          </select>
                        </div>
                        <div class="flex items-center space-x-2 shrink-0 ml-3">
                          <p class="text-sm leading-none font-normal text-black shrink-0">Attendance year</p>
                          <select v-model="year" class="border border-neutral-200 bg-white px-2 py-2 rounded-md text-sm">
                            <option v-for="range in yearRanges" :key="range.value" :value="range.value">
                              {{ range.label }}
                            </option>
                          </select>
                        </div>
                    </div>
                    <div>
                        <div class="grid grid-cols-12 bg-[#ECF6FF] divide-x divide-[#eaeaea]">
                            <div class="text-xs leading-none px-2 py-2 text-[#404A5A] flex items-center font-semibold col-span-2">Employee name</div>
                            <div class="text-xs leading-none px-2 py-2 text-[#404A5A] flex items-center font-semibold justify-center">Employee ID</div>
                            <div class="text-xs leading-none px-2 py-2 text-[#404A5A] flex items-center font-semibold justify-center">Leave type</div>
                            <div class="text-xs leading-none px-2 py-2 text-[#404A5A] flex items-center font-semibold">Leave balance</div>
                            <div class="text-xs leading-none px-2 py-2 text-[#404A5A] flex items-center font-semibold">Allow days to carry</div>
                            <div class="text-xs leading-none px-2 py-2 text-[#404A5A] flex items-center font-semibold justify-center">Incash</div>
                            <div class="text-xs leading-none px-2 py-2 text-[#404A5A] flex items-center font-semibold justify-center">Carry</div>
                            <div class="text-xs leading-none px-2 py-2 text-[#404A5A] flex items-center font-semibold justify-center">Cash</div>
                            <div class="text-xs leading-none px-2 py-2 text-[#404A5A] flex items-center font-semibold justify-center">Action</div>
                        </div>

                        <div v-if="isLoading">
                            <div class="grid grid-cols-12 bg-white divide-x-[1px] shadow mt-1.5 animate-pulse" v-for="index in 6" :key="index">
                                <div class="px-2 py-2 col-span-2">
                                    <span class="w-full rounded h-5 bg-neutral-200 block"></span>
                                </div>
                                <div class="px-2 py-2" v-for="index in 8" :key="index">
                                    <span class="w-full rounded h-5 bg-neutral-200 block"></span>
                                </div>
                            </div>
                        </div>

                        <!-- loop area -->
                        <div v-else>
                          <!-- No data found -->
                          <div v-if="leaveRecords.length === 0" class="text-center py-4 text-neutral-500 text-sm">
                            No data found.
                          </div>
                          <div v-for="(record, index) in leaveRecords" :key="index" class="grid grid-cols-12 bg-white divide-x divide-y divide-[#eaeaea]">
                            <div class="text-sm leading-none px-2 py-2 flex items-center font-normal col-span-2 border-t border-[#eaeaea]">{{ record.fname }} {{ record.lname }}</div>
                            <div class="text-sm leading-none px-2 py-2 flex items-center font-normal justify-center">{{ record.empid }}</div>

                            <div class="text-sm leading-none px-2 py-2 flex items-center font-normal justify-center">{{ record.leave_name }}</div>
                            <div class="text-xs leading-none px-2 py-2 flex items-center font-normal">{{ record.leave_left }}</div>
                            <div class="text-xs leading-none px-2 py-2 flex items-center font-normal justify-center">{{ record.leave_carry_fwd_limit?record.leave_carry_fwd_limit:'N/A'}}</div>
                            <div class="text-xs leading-none px-2 py-2 flex items-center font-normal justify-center">{{ record.leave_encashment_limit?record.leave_encashment_limit:'N/A' }} </div>
                            <div class="text-xs leading-none px-2 py-1 flex items-center font-normal justify-center">
                                {{ record.carry }}
                            </div>
                            <div class="text-xs leading-none px-2 py-1 flex items-center font-normal justify-center">
                                {{ record.cash }}
                            </div>
                            <div class="text-xs leading-none px-2 py-2 flex items-center font-normal justify-center" >
                                <a href="#" class="inline-flex items-center justify-center bg-blue-400 rounded-md px-3 py-2 text-white text-xs font-normal" :class="[record.carry_status && (record.cash || record.carry) ? 'disabled bg-gray-400 cursor-not-allowed' : 'hover:bg-blue-500']" @click="submitRecord(index)"  :disabled="record.carry_status && (record.cash || record.carry)">
                                  Approved
                                </a>
                            </div>
                          </div>
                        </div>
                    </div>
                  </div>
              </div>    
          </div>
          <!-- <RightSideBar /> -->
      </section>
    <!-- </AdminLayout> -->
</template>

<script>
    // import AdminLayout from '../AdminDashboard/AdminLayout.vue';
    // import RightSideBar from '../../components/RightSideBar.vue';
    //import Datepicker from '@vuepic/vue-datepicker'
    import '@vuepic/vue-datepicker/dist/main.css'
    import axios from 'axios';
    import { BASE_URL} from "../../config";
    import { createToast } from 'mosha-vue-toastify';
    import { createLocal } from 'the-storages';
    const mirror = createLocal();
    const storage = mirror._prx;
    export default {
        name: 'LeaveListing',
        components: {
            // AdminLayout,
            // RightSideBar,
            //Datepicker
        },
        data() {
      return {
        year: null,
        yearRanges: [],
        currentStartDate: '',
        currentEndDate: '',
        previousStartDate: '',
        previousEndDate: '',
        leaveRecords: [],
        recordInputs: [],
        storage:storage,  
        branchList: [],  
        slectedLocation: '',   
        userType: '',  
        isLoading: true,
      };
    },
    async mounted() {
      await this.getFinancialYearInfo();
    },
    methods: {
        tostMessage(type, message) {
            createToast({ description: message }, {
                type,
                timeout: 2500,
                position: 'bottom-right',
                showIcon: true
            });
        },

      async getFinancialYearInfo() {
        try {
          const res = await axios.get(`${BASE_URL}/company-financial-year`);
          const type = res.data.financialYear;
          const now = new Date();
          const year = now.getFullYear();
  
          if (type === 'CY') {
            this.currentStartDate = `${year}-01-01`;
            this.currentEndDate = `${year}-12-31`;
            this.previousStartDate = `${year - 1}-01-01`;
            this.previousEndDate = `${year - 1}-12-31`;
          } else if (type === 'FY') {
            const fyStart = new Date(year, 3, 1);
            if (now >= fyStart) {
              this.currentStartDate = `${year}-04-01`;
              this.currentEndDate = `${year + 1}-03-31`;
              this.previousStartDate = `${year - 1}-04-01`;
              this.previousEndDate = `${year}-03-31`;
            } else {
              this.currentStartDate = `${year - 1}-04-01`;
              this.currentEndDate = `${year}-03-31`;
              this.previousStartDate = `${year - 2}-04-01`;
              this.previousEndDate = `${year - 1}-03-31`;
            }
          }
  
          this.yearRanges = [{
            label: `${this.previousStartDate} to ${this.previousEndDate}`,
            value: `${this.previousStartDate}__${this.previousEndDate}`
          }];
          this.year = `${this.previousStartDate}__${this.previousEndDate}`;
          await this.fetchLeaveRecords();
        } catch (err) {
          console.error("Failed to fetch financial year info", err);
        }
      },
      async fetchLeaveRecords() {
        this.isLoading = true;
        try {
          const res = await axios.get(`${BASE_URL}/get-all-leave-records?filter_by=all`, {
            params: {
              start_date: this.previousStartDate, // should be in 'YYYY-MM-DD' format
              end_date: this.previousEndDate,
              location: this.slectedLocation,
            }
          });
          this.leaveRecords = res.data;
          // Initialize inputs
          this.recordInputs = res.data.map(record => ({
            carry: record.leave_carry_fwd_limit === null ? 0 : record.carry,
            cash: record.leave_encashment_limit === null ? 0 : record.cash
          }));
        } catch (error) {
          console.error('Error fetching leave records:', error);
        }finally {
         this.isLoading = false;
        }
      },
      submitRecord(index) {
        const record = this.leaveRecords[index];
        // const payload = {
        //     id: record.id.$oid, // Make sure your backend expects _id in body
        //     employee_uid: record.employee_uid,
        //     carry,
        //     cash
        // };
       // Passed all validations
       const payload = {
            id: record.id,
            leave_id: record.leave_id,
            employee_uid: record.employee_uid,
            carry: record.carry,
            cash:  record.cash,
            start_date: this.currentStartDate,
            end_date: this.currentEndDate,
            company_id:record.company_id,
        };

          // ✅ API call or further processing here...
            axios.post(`${BASE_URL}/approve-cash-carry-leaves`, payload)
            .then(response => {
                this.tostMessage('success',response.data.message || 'Updated successfully!');
                this.fetchLeaveRecords();
            })
            .catch(error => {
            console.error('❌ Error updating leave record:', error);
            this.tostMessage('danger',
                error.response?.data?.message || 'Failed to update leave record.'
            );
            });
      },
      async getBranchList() {
                const formData = {
                    "company_id":this.storage.companyDetails.id
                };
                await axios.post(BASE_URL + '/get-emp-branch-list',formData)
                .then((response)=>{
                    this.branchList =  response.data.branchDetails;
                    console.log("Role LIST:: ",response.data);
                })
            },
      },
    created() {
        if (this.storage.userType === 'Super Admin') {               
                this.slectedLocation = ''; // Set to an empty string or a default value
                this.userType = 'admin';
            } else {
                this.slectedLocation = this.storage.employeeDetails.branch; // Assign only if branch is valid
                this.userType = 'not-admin';
                console.log('branch', this.slectedLocation);
            }
           this.getBranchList();
    },
    }
</script>

<style scoped>
/* Remove default input focus */
    input:focus {
        outline: none;
    }
</style>
